import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { array, shape, string, number, func, arrayOf, bool } from 'prop-types';
import { Select } from '../../atoms';
import { ReviewCharacteristics, ReviewCard } from '../../organisms';
import { Container, Divider, ReviewList, Button, Line, ImageItem, Title, TitleReviewCharacteristics, SelectReviewSort } from './review-result.styles';

function ReviewResult({
  productData,
  reviewsData,
  onViewMoreClick,
  onChangeSort,
  showDesktop
}) {
  const {
    title,
    image
  } = productData || {};
  const {
    stats = {},
    reviews = [],
    sorts = [],
    pagination = {}
  } = reviewsData || {};
  const sortOptions = sorts == null ? void 0 : sorts.map(({
    label,
    type,
    orientation,
    selected
  }) => ({
    label,
    selected,
    value: `${type}-${orientation}`
  }));

  const handleChange = value => {
    if (value) {
      const [vType, vOrien] = value.split('-');
      const item = sorts == null ? void 0 : sorts.find(({
        type,
        orientation
      }) => type === vType && orientation === vOrien);
      onChangeSort(item);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Line, {
    p: "16px"
  }, /*#__PURE__*/React.createElement(ImageItem, {
    src: image,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement(Title, null, title)), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Divider, {
    m: "16px 0px",
    display: ['none', 'block']
  }), /*#__PURE__*/React.createElement(TitleReviewCharacteristics, null, "Avalia\xE7\xE3o geral"), /*#__PURE__*/React.createElement(ReviewCharacteristics, stats), /*#__PURE__*/React.createElement(Divider, {
    m: "16px 0px"
  }), !showDesktop && /*#__PURE__*/React.createElement(SelectReviewSort, null, /*#__PURE__*/React.createElement(Select, {
    id: "review-result",
    options: sortOptions,
    onChange: handleChange,
    mb: 20,
    "data-testid": "review-sort"
  })), showDesktop && /*#__PURE__*/React.createElement(SelectReviewSort, null, /*#__PURE__*/React.createElement(Select, {
    id: "review-result",
    options: sortOptions,
    onChange: handleChange,
    mb: 20,
    "data-testid": "review-sort",
    desktopMode: true,
    textLabel: "Ordenar avalia\xE7\xF5es:"
  })), /*#__PURE__*/React.createElement(ReviewList, null, reviews == null ? void 0 : reviews.map((item, idx) => /*#__PURE__*/React.createElement(ReviewCard, _extends({
    key: `review-${idx}`
  }, item)))), (pagination == null ? void 0 : pagination.page) < (pagination == null ? void 0 : pagination.pages) && /*#__PURE__*/React.createElement(Button, {
    "data-testid": "review-more",
    onClick: onViewMoreClick
  }, "Carregar Mais")));
}

process.env.NODE_ENV !== "production" ? ReviewResult.propTypes = {
  productData: shape({
    image: string,
    title: string
  }),
  reviewsData: shape({
    stats: shape({
      count: number,
      average: number
    }),
    reviews: array,
    sorts: arrayOf(shape({
      type: string.isRequired,
      label: string.isRequired,
      orientation: string.isRequired
    }))
  }),
  onViewMoreClick: func,
  onChangeSort: func,
  showDesktop: bool
} : void 0;
ReviewResult.defaultProps = {
  showDesktop: false
};
export default ReviewResult;